import _ from 'lodash'
import courierApi from '@/api/courier'
import store from '@/store'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  list: [],
  totalCount: 0,
  loading: false,

  syncing: false,
  filters: {
    pageNumber: 1,
    pageSize: 10,
    searchQuery: '',
    sortBy: '',
    sortDesc: false,
  },
}

const getters = {}

const syncedText = ({
  total, added, updated, deactivated,
}) => `Курьеров в Delivery: ${total}. Добавлено: ${added}, обновлено: ${updated}, отключено: ${deactivated}`

const actions = {
  fetchList({ commit }) {
    commit('LIST_LOADING')

    return courierApi.getAll({ ...state.filters })
      .then(({ data }) => commit('SET_LIST', data))
      .catch(error => commit('LIST_FAILED', error.response?.data?.message))
  },
  sync({ commit }) {
    commit('SYNC_STARTED')

    return courierApi.sync()
      .then(({ data }) => commit('COURIERS_SYNCED', data))
      .catch(error => commit('COURIERS_SYNC_FAILED', error.response?.data?.message))
  },
}

const mutations = {
  LIST_LOADING(state) {
    state.loading = true
  },
  SET_LIST(state, { items, metadata }) {
    state.list = items
    state.totalCount = metadata.totalItemCount
    state.loading = false
  },
  LIST_FAILED(state, message) {
    state.list = []
    state.totalCount = 0
    state.loading = false
    store.dispatch('message/error', message || 'Не удалось прочитать справочник курьеров')
  },
  SYNC_STARTED(state) {
    state.syncing = true
    store.dispatch('message/load')
  },
  COURIERS_SYNCED(state, result) {
    state.syncing = false
    store.dispatch('message/loadFinish')
    store.dispatch('message/success', syncedText(result))
    store.dispatch('courier/fetchList')
  },

  COURIERS_SYNC_FAILED(state, message) {
    state.syncing = false
    store.dispatch('message/loadFinish')
    store.dispatch('message/error', message || 'Не удалось синхронизировать курьеров')
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = [
  [
    ({ courier: { filters } }) => filters.searchQuery,
    () => store.commit('courier/FORM_UPDATE_FIELD', { key: 'filters.pageNumber', value: 1 }),
  ],
  [
    state => state.courier.filters,
    _.debounce(async () => await store.dispatch('courier/fetchList'), 250),
    { immediate: false, deep: true },
  ],
]

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
